import { Button } from '@sunwebgroup/uds-ui/button'
import { Dialog } from '@sunwebgroup/uds-ui/dialog'
import { useIntl } from 'react-intl'
import { getRebookedBookingUrl } from '@/scopes/account/booking-details/domain/policies/getRebookedBookingUrl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useBookingDetailsStore } from '../../infrastructure/useBookingDetailsStore'
import styles from './RebookedMessage.module.css'

interface RebookedMessageProps {
  bookingNumber: string
}

export function RebookedMessage({ bookingNumber }: RebookedMessageProps) {
  const { formatMessage } = useIntl()
  const siteName = useConfiguration('siteName')
  const isGroupBooking = useBookingDetailsStore(state => state.isGroupBooking)
  const rebookedUrl = getRebookedBookingUrl({ siteName, bookingNumber, isGroupBooking })

  return (
    <Dialog
      type="custom"
      icon="InformationInCircle"
      text={formatMessage({ id: 'booking_details_rebooked_title' })}
      supportingText={formatMessage({ id: 'booking_details_rebooked_text' })}
      actionsSlot={(
        <Button as="a" href={rebookedUrl} className={styles.button}>
          {formatMessage({ id: 'booking_details_rebooked_cta' })}
        </Button>
      )}
    />
  )
}
